import { jsx as _jsx } from "react/jsx-runtime";
import { AccordionItem, AccordionList } from "../../common";
import { MinusOutlined } from "@ant-design/icons-svg";
import { findUsedGcmConsentTypes } from "@devowl-wp/cookie-consent-web-client";
import { useBannerOrBlocker } from "../../../hooks";
const GcmConsentTypesList = (param)=>{
    let { services } = param;
    const usedPurposes = findUsedGcmConsentTypes(services);
    const { i18n: { gcm: { purposes: i18nPurposes } } } = useBannerOrBlocker();
    return /*#__PURE__*/ _jsx(AccordionList, {
        children: usedPurposes.map((purpose)=>/*#__PURE__*/ _jsx(AccordionItem, {
                title: i18nPurposes[purpose],
                icon: MinusOutlined,
                expandable: false
            }, purpose))
    });
};
export { GcmConsentTypesList };
